export interface CheckbookCategoryOption {
  value: number;
  label: string;
}
export interface EditableColumnCategories {
  field: string;
  title: string;
  show: boolean;
  display: boolean;
}

export const viewCheckbookCategories: CheckbookCategoryOption[] = [
  { value: 0, label: 'Show All' },
  { value: 1, label: 'Show All Undeleted' },
  { value: 2, label: 'Show Active and Undeleted' },
  { value: 3, label: 'Show Inactive and Undeleted' },
  { value: 4, label: 'Show All Deleted' },
];

export const initialEditablePeriodColumns: EditableColumnCategories[] = [
  { field: 'departments', title: 'Departments', show: true, display: true },
  { field: 'initialBudget', title: 'Budget Amt', show: true, display: true },
  { field: 'budgetAmount', title: 'Forecast Amt', show: true, display: true },
  { field: 'holdAmount', title: 'Planned Amt', show: true, display: true },
  { field: 'committedAmount', title: 'Committed Amt', show: true, display: true },
  { field: 'spentAmount', title: 'Actualized Amt', show: true, display: true },
  { field: 'remainingInitialBudgetAmount', title: '$ Remaining Budget', show: true, display: true },
  {
    field: 'remainingInitialBudgetAmountPercentage',
    title: '% Remaining Budget',
    show: true,
    display: true,
  },
  { field: 'remainingBudgetAmount', title: '$ Remaining Forecast', show: true, display: true },
  {
    field: 'remainingBudgetAmountPercentage',
    title: '% Remaining Forecast',
    show: true,
    display: true,
  },
  { field: 'journalEntry', title: 'Journal Entry', show: true, display: true },
  { field: 'transaction', title: 'Transaction Log', show: true, display: true },
  { field: 'isFixed', title: 'Fixed Code', show: true, display: true },
  { field: 'isActive', title: 'Active Code', show: true, display: true },
  { field: 'poApproval', title: 'PO Approval Exceptions', show: true, display: true },
  { field: 'invoiceApproval', title: 'Invoice Approval Exceptions', show: true, display: true },
];

export const initialEditableYearColumns: EditableColumnCategories[] = [
  { field: 'departments', title: 'Departments', show: true, display: true },
  { field: 'isFixed', title: 'Fixed Code', show: true, display: true },
  { field: 'isActive', title: 'Active Code', show: true, display: true },
  { field: 'AcrossCell', title: 'Action', show: true, display: true },
  { field: 'initialBudgetPeriod', title: 'Budget Amt', show: true, display: true },
  { field: 'budgetPeriod', title: 'Forecast Amt', show: true, display: true },
];

export const deleteAvailableCategories = [0, 1, 2, 3];
export const undeleteAvailableCategories = [0, 4];
export const adjustBudgetAvailableCategories = [0, 1, 2, 3];

const useCheckbookCategories = () => {
  const categories = [...viewCheckbookCategories];
  return categories;
};

export default useCheckbookCategories;
